/**
 * Promoboxes Modal Handler
 * Handles opening/closing of "Что в составе?" modal windows
 */

class PromoboxesModal {
  constructor() {
    this.init();
  }

  init() {
    // Обработчик клика на кнопку "Что внутри?"
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-modal-trigger]');
      if (trigger) {
        const modalId = trigger.getAttribute('data-modal-trigger');
        this.openModal(modalId);
      }
    });

    // Обработчик клика на закрытие модального окна
    document.addEventListener('click', (e) => {
      const closeBtn = e.target.closest('[data-modal-close]');
      if (closeBtn) {
        const modalId = closeBtn.getAttribute('data-modal-close');
        this.closeModal(modalId);
      }
    });

    // Закрытие по клику на фон
    document.addEventListener('click', (e) => {
      if (e.target.classList.contains('box-product-card-modal-bg')) {
        const modal = e.target.closest('.box-product-card-modal');
        if (modal) {
          this.closeModal(modal.id);
        }
      }
    });

    // Закрытие по Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        const openModal = document.querySelector('.box-product-card-modal.open');
        if (openModal) {
          this.closeModal(openModal.id);
        }
      }
    });

    // Предотвращаем закрытие при клике на контент модального окна
    document.addEventListener('click', (e) => {
      if (e.target.closest('.box-product-card-modal-content')) {
        e.stopPropagation();
      }
    });
  }

  openModal(modalId) {
    const modal = document.getElementById(modalId);
    if (!modal) return;

    // Закрываем все другие модальные окна
    document.querySelectorAll('.box-product-card-modal.open').forEach(m => {
      if (m.id !== modalId) {
        this.closeModal(m.id);
      }
    });

    modal.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  closeModal(modalId) {
    const modal = document.getElementById(modalId);
    if (!modal) return;

    modal.classList.remove('open');
    
    // Убираем блокировку скролла только если нет других открытых модальных окон
    const hasOpenModals = document.querySelector('.box-product-card-modal.open');
    if (!hasOpenModals) {
      document.body.style.overflow = '';
    }
  }
}

// Инициализация при загрузке DOM
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new PromoboxesModal();
  });
} else {
  new PromoboxesModal();
}
